import { connect, mapProps } from '@formily/react';
import { CnOSSImageUpload as _CnOSSImageUpload, } from '@/components/cn-oss-image-upload';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnOSSImageUpload = connect(_CnOSSImageUpload, mapProps(mapSize, mapStatus));
CnOSSImageUpload.displayName = 'CnOSSImageUpload';
